/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import MainPage from "./sub-comp/MainPage";
import SideBarMenu from "./sub-comp/SideBarMenu";
import "../../../css/Dashboard/home/Home.css";
import {
  authActionCreators,
  messagesActionCreators,
  navigationActionCreators,
  notificationsActionCreators,
  userDataActionCreators,
} from "../../../service/action-creators";
import LoadingSpinner from "../../../components/Loader";

function RenderHome(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [isCheckingVerification, setIsCheckingVerification] = useState(true);

  // Initialize action creators
  const { closeSideBarOnMobile } = bindActionCreators(
    navigationActionCreators,
    dispatch
  );
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);
  const { GetConversations } = bindActionCreators(
    messagesActionCreators,
    dispatch
  );
  const { GetNotifications } = bindActionCreators(
    notificationsActionCreators,
    dispatch
  );
  const { GetCartProducts } = bindActionCreators(
    userDataActionCreators,
    dispatch
  );

  useEffect(() => {
    if (auth?.user) {
      if (auth.user.is_email_verified === false) {
        history.replace("/account/resend-email-verification-link");
      } else {
        setIsCheckingVerification(false);
      }
    }
  }, [auth?.user, history]);

  useEffect(() => {
    if (auth?.user?.is_email_verified !== false) {
      closeSideBarOnMobile();
      GetUserProfile();
      GetCartProducts();
      GetNotifications();
      GetConversations(auth?.user?._id);
    }
  }, [auth?.user?._id, auth?.user?.is_email_verified]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (isCheckingVerification || auth?.user?.is_email_verified === false) {
    return <LoadingSpinner fullPage />;
  }

  return (
    <div className="home_dashboard">
      <SideBarMenu />
      <MainPage>
        <div className="DashBoardTitle" style={{ justifyContent: "center" }}>
          <h4 className="pageTitle">{props.title}</h4>
        </div>
        <div className="pb-6">{props.children}</div>
      </MainPage>
    </div>
  );
}

export default RenderHome;
